import { Image } from '@chakra-ui/react';
import React from 'react';
import logo from '@/assets/chromabet/images/logo-footer.png';

export default function Index() {
  return <Image src={logo} maxW="150px" />;
}
